import { Metadata } from '@tencent/workbench-core';
import { ParamMetadata } from '../providers/param/param-metadata.js';

const PARAM_METADATA = 'workbench:params:metadata';
class ParamRegistry {
    static get(target, targetKey, index) {
        const params = this.getParams(target, targetKey);
        params[index] = params[index] || new ParamMetadata(target, targetKey, index);
        return params[index];
    }
    static set(target, targetKey, index, injectParams) {
        const params = Metadata.has(PARAM_METADATA, target, targetKey)
            ? Metadata.get(PARAM_METADATA, target, targetKey)
            : [];
        params[index] = injectParams;
        Metadata.set(PARAM_METADATA, params, target, targetKey);
    }
    static usePreHandler(service, settings) {
        const param = ParamRegistry.get(settings.target, settings.propertyKey, settings.parameterIndex);
        param.service = service;
        if (settings.expression) {
            param.expression = settings.expression;
        }
        if (settings.useFunction) {
            param.converter = settings.useFunction;
        }
        ParamRegistry.set(settings.target, settings.propertyKey, settings.parameterIndex, param);
        return this;
    }
    /**
     * 创建一个参数装饰器
     * @param token - 参数装饰器的 key
     * @param options - 参数装饰器的选项
     */
    static decorate(token, options = {}) {
        return (target, propertyKey, parameterIndex) => {
            if (typeof parameterIndex === 'number') {
                const settings = Object.assign({
                    target,
                    propertyKey,
                    parameterIndex,
                }, options);
                if (typeof token === 'symbol') {
                    ParamRegistry.usePreHandler(token, settings);
                }
            }
        };
    }
}
ParamRegistry.getParams = (target, targetKey) => (Metadata.has(PARAM_METADATA, target, targetKey)
    ? Metadata.get(PARAM_METADATA, target, targetKey)
    : []);
ParamRegistry.isInjectable = (target, method) => {
    var _a;
    return (((_a = Metadata.get(PARAM_METADATA, target, method)) !== null && _a !== void 0 ? _a : []).length > 0);
};

export { PARAM_METADATA, ParamRegistry };
//# sourceMappingURL=param-registry.js.map
